if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper ? this.productWrapper.querySelector('.product-images') : null;
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateVariantText();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const optionValues = this.options || [];
      const allVariantSelects = document.querySelectorAll('variant-selects');
      allVariantSelects.forEach((vs) => {
        const fieldsets = Array.from(vs.querySelectorAll('fieldset'));
        fieldsets.forEach((fieldset, i) => {
          let label = fieldset.querySelector('.form__label__value');
          if (!label) label = fieldset.querySelector('.form_label_value');
          if (!label) label = fieldset.querySelector('.form__label span');
          if (!label || optionValues[i] == null) return;
          label.textContent = optionValues[i];
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.productWrapper) {
        this.productWrapper = this.closest('.thb-product-detail');
      }
      let productSlider = this.productWrapper ? this.productWrapper.querySelector('.product-images') : null;
      let thumbnails = this.productWrapper ? this.productWrapper.querySelector('#Product-Thumbnails') : null;
      if (!productSlider && document.querySelector('.thb-product-detail')) {
        productSlider = document.querySelector('.thb-product-detail .product-images');
        thumbnails = document.querySelector('.thb-product-detail #Product-Thumbnails');
      }
      if (!productSlider) return;

      const sectionId = this.dataset.section;
      const variantId = this.currentVariant.id;
      let mediaId = null;
      let thumbId = null;

      const mapEl = document.getElementById(`VariantMediaMap-${sectionId}`);
      if (mapEl) {
        try {
          const mapping = JSON.parse(mapEl.textContent);
          const entry = Array.isArray(mapping) ? mapping.find(m => m.id === variantId) : null;
          if (entry && entry.media_id != null) {
            mediaId = `#Slide-${sectionId}-${entry.media_id}`;
            thumbId = `#Thumb-${sectionId}-${entry.media_id}`;
          }
        } catch (e) { /* ignore */ }
      }

      if (!mediaId && this.currentVariant.featured_media) {
        mediaId = `#Slide-${sectionId}-${this.currentVariant.featured_media.id}`;
        thumbId = `#Thumb-${sectionId}-${this.currentVariant.featured_media.id}`;
      }
      if (!mediaId && this.currentVariant.featured_image) {
        mediaId = `#Slide-${sectionId}-${this.currentVariant.featured_image.id}`;
        thumbId = `#Thumb-${sectionId}-${this.currentVariant.featured_image.id}`;
      }

      if (!mediaId) {
        const slides = productSlider.querySelectorAll('.product-images__slide[data-variant-ids]');
        const variantIdStr = String(variantId);
        for (let i = 0; i < slides.length; i++) {
          const ids = (slides[i].getAttribute('data-variant-ids') || '').split(',').map(s => s.trim());
          if (ids.indexOf(variantIdStr) !== -1) {
            mediaId = `#${slides[i].id}`;
            const mediaIdNum = slides[i].id.replace(/^Slide-[^-]+-/, '');
            thumbId = thumbnails ? `#Thumb-${sectionId}-${mediaIdNum}` : null;
            break;
          }
        }
      }

      if (!mediaId) {
        const first = productSlider.querySelector('.product-images__slide');
        if (first) {
          mediaId = `#${first.id}`;
          const mediaIdNum = first.id.replace(/^Slide-[^-]+-/, '');
          thumbId = thumbnails ? `#Thumb-${sectionId}-${mediaIdNum}` : null;
        }
      }

      if (mediaId && productSlider.querySelector(mediaId)) {
        this.setActiveMedia(mediaId, thumbId, productSlider, thumbnails);
      }
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      if (!productSlider) return;
      const activeMedia = productSlider.querySelector(mediaId);
      if (!activeMedia) return;

      const flkty = Flickity.data(productSlider);

      if (flkty && this.hideVariants) {
        const initialSelected = productSlider.querySelector('.product-images__slide.is-initial-selected');
        if (initialSelected) initialSelected.classList.remove('is-initial-selected');
        productSlider.querySelectorAll('.product-images__slide-item--variant').forEach(el => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');
        this.setImageSetMedia();
        if (thumbnails) {
          const activeThumb = thumbId ? thumbnails.querySelector(thumbId) : null;
          if (activeThumb) {
            const sel = thumbnails.querySelector('.product-thumbnail.is-initial-selected');
            if (sel) sel.classList.remove('is-initial-selected');
            thumbnails.querySelectorAll('.product-images__slide-item--variant').forEach(el => el.classList.remove('is-active'));
            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
          }
        }
        if (this.imageSetIndex !== undefined) {
          productSlider.reInit(this.imageSetIndex);
        }
        productSlider.selectCell(mediaId);
        return;
      }

      if (flkty) {
        productSlider.querySelectorAll('.product-images__slide').forEach(s => s.classList.remove('is-initial-selected'));
        activeMedia.classList.add('is-initial-selected');
        if (thumbnails) {
          thumbnails.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('is-initial-selected'));
          const activeThumb = thumbId ? thumbnails.querySelector(thumbId) : null;
          if (activeThumb) activeThumb.classList.add('is-initial-selected');
        }
        
        // Verificar que el slide no esté oculto antes de intentar seleccionarlo
        if (activeMedia.classList.contains('hide-slide')) {
          // Si está oculto, seleccionar el primer slide visible en su lugar
          const firstVisible = productSlider.querySelector('.product-images__slide:not(.hide-slide)');
          if (firstVisible) {
            const firstVisibleIndex = flkty.cells.findIndex(c => c.element === firstVisible);
            if (firstVisibleIndex !== -1) {
              flkty.select(firstVisibleIndex);
            }
          }
          return;
        }
        
        const cellIndex = flkty.cells.findIndex(c => c.element === activeMedia);
        const doSelect = () => {
          if (cellIndex !== -1) {
            flkty.select(cellIndex);
          } else {
            productSlider.selectCell(mediaId);
          }
        };
        requestAnimationFrame(doSelect);
        return;
      }

      productSlider.querySelectorAll('.product-images__slide').forEach(s => s.classList.remove('is-active', 'is-initial-selected'));
      activeMedia.classList.add('is-active', 'is-initial-selected');
      if (thumbnails) {
        thumbnails.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('is-active', 'is-initial-selected'));
        const activeThumb = thumbId ? thumbnails.querySelector(thumbId) : null;
        if (activeThumb) activeThumb.classList.add('is-active', 'is-initial-selected');
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data && this.currentVariant) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('script[type="application/json"]:not([id])').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container ? this.product_container.querySelector('.product-thumbnail-container') : null;
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      this.init();
    }
    disconnectedCallback() {
      if (this._boundOnVariantChange) {
        document.removeEventListener('product:variant-change', this._boundOnVariantChange);
      }
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container ? this.thumbnail_container.querySelectorAll('.product-thumbnail') : [];
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      const inQuickView = !!this.closest('.side-panel-content');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: !inQuickView,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // PDP cambio de variante -> imagen: el slider escucha product:variant-change y selecciona
      // el slide que corresponde al variant (VariantMediaMap o data-variant-ids). Una sola fuente
      // de verdad: quien tiene Flickity (ProductSlider) es quien cambia la imagen.
      this._boundOnVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('product:variant-change', this._boundOnVariantChange);

      // Start Gallery
      this.setupProductGallery();
    }
    onVariantChange(e) {
      const sectionId = e.detail && e.detail.sectionId;
      const variant = e.detail && e.detail.variant;
      const sliderSection = this.dataset.section;

      if (!variant || !sectionId || sectionId !== sliderSection) {
        return;
      }
      if (!this.flkty || !this.flkty.cells) {
        return;
      }

      const vid = String(variant.id);
      let mediaId = null;
      if (typeof window !== 'undefined') window.__pdpVariantImageHandled = false;

      // 1) Preferir slide con data-variant-ids que contenga este variant (imagen asociada en DOM)
      const slidesWithVariants = this.querySelectorAll('.product-images__slide[data-variant-ids]');
      for (let i = 0; i < slidesWithVariants.length; i++) {
        const ids = (slidesWithVariants[i].getAttribute('data-variant-ids') || '').split(',').map(s => s.trim());
        if (ids.indexOf(vid) !== -1) {
          mediaId = `#${slidesWithVariants[i].id}`;
          break;
        }
      }

      if (!mediaId) {
        const mapEl = document.getElementById(`VariantMediaMap-${sectionId}`);
        if (mapEl) {
          try {
            const mapping = JSON.parse(mapEl.textContent);
            const entry = Array.isArray(mapping) ? mapping.find(m => m.id == variant.id || String(m.id) === vid) : null;
            if (entry && entry.media_id != null) {
              mediaId = `#Slide-${sectionId}-${entry.media_id}`;
            }
          } catch (err) { /* ignore */ }
        }
      }
      if (!mediaId && variant.featured_media) {
        mediaId = `#Slide-${sectionId}-${variant.featured_media.id}`;
      }
      if (!mediaId && variant.featured_image) {
        mediaId = `#Slide-${sectionId}-${variant.featured_image.id}`;
      }
      if (!mediaId) {
        return;
      }

      const slideEl = this.querySelector(mediaId);

      if (!slideEl) return;

      const inQuickView = !!this.closest('.side-panel-content');
      // slider-config.js usa cellSelector '.product-images__slide:not(.hide-slide)'. Si esta slide
      // tiene hide-slide no está en las celdas y getCell devuelve null. La hacemos visible y recargamos.
      if (slideEl.classList.contains('hide-slide')) {
        slideEl.classList.remove('hide-slide');
        if (typeof this.flkty.reloadCells === 'function') this.flkty.reloadCells();
      }
      if (inQuickView) {
        this.querySelectorAll('.product-images__slide').forEach(s => s.classList.remove('hide-slide'));
        if (typeof this.flkty.reloadCells === 'function') this.flkty.reloadCells();
      }

      let cell = this.flkty.getCell(slideEl);

      let idx = -1;
      if (cell !== null && typeof this.flkty.getCellSlideIndex === 'function') {
        idx = this.flkty.getCellSlideIndex(cell);
      } else if (cell !== null) {
        idx = this.flkty.cells.indexOf(cell);
      }
      if (idx === -1 && typeof this.flkty.getCellElements === 'function') {
        const cellEls = this.flkty.getCellElements();
        idx = Array.prototype.indexOf.call(cellEls, slideEl);
      }
      if (idx === -1 && typeof this.flkty.reloadCells === 'function') {
        this.querySelectorAll('.product-images__slide').forEach(s => s.classList.remove('is-active', 'is-initial-selected'));
        slideEl.classList.add('is-active', 'is-initial-selected');
        this.flkty.reloadCells();
        cell = this.flkty.getCell(slideEl);
        idx = cell !== null && typeof this.flkty.getCellSlideIndex === 'function'
          ? this.flkty.getCellSlideIndex(cell)
          : (cell !== null ? this.flkty.cells.indexOf(cell) : -1);
        if (idx === -1 && typeof this.flkty.getCellElements === 'function') {
          idx = Array.prototype.indexOf.call(this.flkty.getCellElements(), slideEl);
        }
      }
      if (idx === -1 && this.flkty.slider) {
        const sliderChildren = Array.from(this.flkty.slider.children);
        idx = sliderChildren.indexOf(slideEl);
      }
      if (idx === -1) {
        idx = this.flkty.cells.findIndex(c => c && c.element === slideEl);
      }

      if (idx === -1 || typeof idx !== 'number') {
        return;
      }

      this.querySelectorAll('.product-images__slide').forEach(s => s.classList.remove('is-initial-selected', 'is-selected'));
      slideEl.classList.add('is-initial-selected', 'is-selected');

      const thumbnails = this.product_container && this.product_container.querySelector('#Product-Thumbnails');
      if (thumbnails) {
        const prefix = `Slide-${sectionId}-`;
        const mediaIdNum = slideEl.id.startsWith(prefix) ? slideEl.id.slice(prefix.length) : slideEl.id.replace(/^Slide-[^-]+-/, '');
        const thumb = thumbnails.querySelector(`#Thumb-${sectionId}-${mediaIdNum}`);
        if (thumb) {
          if (!inQuickView) {
            thumb.classList.remove('hide-image');
            thumbnails.querySelectorAll('.product-thumbnail').forEach(t => {
              if (t !== thumb && t.classList.contains('product-images__slide-item--variant')) t.classList.add('hide-image');
            });
          } else {
            thumbnails.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('hide-image'));
          }
        }
      }

      const targetSlideEl = slideEl;
      const selectBySlide = () => {
        if (!this.flkty || !targetSlideEl) return;
        const c = this.flkty.getCell(targetSlideEl);
        if (c != null) {
          const i = this.flkty.cells.indexOf(c);
          if (i !== -1) {
            try {
              this.flkty.select(i, false, true);
            } catch (err) {
              console.warn('[product-slider] flkty.select failed', err);
            }
          }
        }
      };
      if (inQuickView) {
        this.flkty.select(Math.max(0, Math.min(idx, this.flkty.slides.length - 1)), false, true);
      } else {
        selectBySlide();
        requestAnimationFrame(selectBySlide);
        setTimeout(selectBySlide, 100);
      }
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      if (!this._boundOnVariantChange) {
        this._boundOnVariantChange = this.onVariantChange.bind(this);
        document.addEventListener('product:variant-change', this._boundOnVariantChange);
      }

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
        const slide = _this.flkty.cells[index]?.element;
        if (slide) _this.syncThumbnailFromSlide(slide);
      });
      this.flkty.on('change', (index) => {
        const currentSlide = this.flkty.cells[index]?.element;
        if (currentSlide) this.syncThumbnailFromSlide(currentSlide);

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media');

        // Stop previous video
        if (previous_media && previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media?.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      if (this.thumbnail_container && !this._thumbnailClickBound) {
        this._thumbnailClickBound = true;
        this.thumbnail_container.addEventListener('click', (event) => {
          const thumbnail = event.target.closest('.product-thumbnail');
          if (!thumbnail || thumbnail.classList.contains('hide-image')) return;
          this.thumbnailClick(thumbnail);
        });
      }

    }
    syncThumbnailFromSlide(slideEl) {
      if (!slideEl || !this.thumbnails?.length) return;

      const thumbId = slideEl.id.replace(/^Slide-/, 'Thumb-');
      const thumb = document.getElementById(thumbId);

      this.thumbnails.forEach((t) => {
        t.classList.remove('is-initial-selected', 'is-selected');
      });

      if (!thumb || thumb.classList.contains('hide-image')) return;

      thumb.classList.add('is-initial-selected', 'is-selected');

      requestAnimationFrame(() => {
        if (thumb.offsetParent === null) return;
        const parent = thumb.offsetParent;
        const windowHalfHeight = parent.clientHeight / 2;
        const windowHalfWidth = parent.clientWidth / 2;
        parent.scrollTo({
          left: thumb.offsetLeft - windowHalfWidth + thumb.clientWidth / 2,
          top: thumb.offsetTop - windowHalfHeight + thumb.clientHeight / 2,
          behavior: 'smooth'
        });
      });
    }

    thumbnailClick(thumbnail) {
      if (!this.flkty || !thumbnail) return;

      const slideId = thumbnail.id.replace(/^Thumb-/, 'Slide-');
      const slideEl = this.querySelector(`#${slideId}`);
      if (!slideEl) return;

      if (slideEl.classList.contains('hide-slide')) {
        slideEl.classList.remove('hide-slide');
        if (typeof this.flkty.reloadCells === 'function') {
          this.flkty.options.cellSelector = '.product-images__slide:not(.hide-slide)';
          this.flkty.reloadCells();
        }
      }

      const cell = this.flkty.getCell(slideEl);
      if (cell != null) {
        const i = this.flkty.cells.indexOf(cell);
        if (i !== -1) {
          this.flkty.select(i, false, true);
          this.syncThumbnailFromSlide(slideEl);
          return;
        }
      }

      if (typeof this.flkty.selectCell === 'function') {
        this.flkty.selectCell(`#${slideId}`);
      }
      this.syncThumbnailFromSlide(slideEl);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}